import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const HanaResultMob = () => {
  return <CommonResult />;
};

export default HanaResultMob;
